/**
 * Theme Presets for SimpleCMS
 * Пресеты цветовых тем для сайтов
 */

export const THEME_PRESETS = {
  default: {
    id: 'default',
    name: 'Стандартная',
    colors: {
      // Соответствует tailwind.css приложения
      primary: '#2B5A87',
      primaryForeground: '#FFFFFF',
      background: '#FAFBFC',
      foreground: '#1A1A1A',
      card: '#FFFFFF',
      cardForeground: '#2D3748',
      muted: '#F7FAFC',
      mutedForeground: '#4A5568',
      border: '#E2E8F0',
      textSecondary: '#4A5568',
      error: '#E53E3E',
      warning: '#D69E2E',
      success: '#38A169',
    },
    typography: {
      // Соответствует шрифтам приложения
      fontFamily: '"Source Sans 3", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
      fontFamilyHeading: '"Manrope", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    },
    radius: {
      // Соответствует tailwind.css приложения
      xs: '6px',
      sm: '8px',
      md: '12px',
      lg: '18px',
      xl: '24px',
      '2xl': '32px',
      full: '9999px',
    }
  },
  warmEarth: {
    id: 'warmEarth',
    name: 'Тёплая земля',
    colors: {
      primary: '#b45309',
      primaryForeground: '#ffffff',
      background: '#fffbeb',
      foreground: '#422006',
      card: '#ffffff',
      cardForeground: '#422006',
      muted: '#fef3c7',
      mutedForeground: '#92400e',
      border: '#fcd34d',
      textSecondary: '#92400e',
      error: '#dc2626',
      warning: '#d97706',
      success: '#16a34a',
    },
    typography: {
      fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif',
      fontFamilyHeading: 'Georgia, Cambria, "Times New Roman", Times, serif',
    },
    radius: {
      xs: '0.125rem',
      sm: '0.25rem',
      md: '0.375rem',
      lg: '0.5rem',
      xl: '0.75rem',
      '2xl': '1rem',
      full: '9999px',
    }
  },
  forest: {
    id: 'forest',
    name: 'Лесная',
    colors: {
      primary: '#166534',
      primaryForeground: '#ffffff',
      background: '#f0fdf4',
      foreground: '#14532d',
      card: '#ffffff',
      cardForeground: '#14532d',
      muted: '#dcfce7',
      mutedForeground: '#166534',
      border: '#86efac',
      textSecondary: '#166534',
      error: '#dc2626',
      warning: '#ca8a04',
      success: '#15803d',
    },
    typography: {
      fontFamily: '"Nunito Sans", system-ui, -apple-system, sans-serif',
      fontFamilyHeading: '"Nunito Sans", system-ui, -apple-system, sans-serif',
    },
    radius: {
      xs: '0.375rem',
      sm: '0.5rem',
      md: '0.75rem',
      lg: '1rem',
      xl: '1.5rem',
      '2xl': '2rem',
      full: '9999px',
    }
  },
  darkElegant: {
    id: 'darkElegant',
    name: 'Тёмный элегант',
    colors: {
      primary: '#a855f7',
      primaryForeground: '#ffffff',
      background: '#0f0f0f',
      foreground: '#fafafa',
      card: '#1a1a1a',
      cardForeground: '#fafafa',
      muted: '#262626',
      mutedForeground: '#a3a3a3',
      border: '#404040',
      textSecondary: '#a3a3a3',
      error: '#f87171',
      warning: '#fbbf24',
      success: '#4ade80',
    },
    typography: {
      fontFamily: '"Inter", system-ui, -apple-system, sans-serif',
      fontFamilyHeading: '"Inter", system-ui, -apple-system, sans-serif',
    },
    radius: {
      xs: '0.125rem',
      sm: '0.25rem',
      md: '0.375rem',
      lg: '0.5rem',
      xl: '0.75rem',
      '2xl': '1rem',
      full: '9999px',
    }
  },
  oceanBreeze: {
    id: 'oceanBreeze',
    name: 'Океан',
    colors: {
      primary: '#0891b2',
      primaryForeground: '#ffffff',
      background: '#ecfeff',
      foreground: '#164e63',
      card: '#ffffff',
      cardForeground: '#164e63',
      muted: '#cffafe',
      mutedForeground: '#0e7490',
      border: '#67e8f9',
      textSecondary: '#0e7490',
      error: '#dc2626',
      warning: '#d97706',
      success: '#059669',
    },
    typography: {
      fontFamily: '"Open Sans", system-ui, -apple-system, sans-serif',
      fontFamilyHeading: '"Montserrat", system-ui, -apple-system, sans-serif',
    },
    radius: {
      xs: '0.375rem',
      sm: '0.5rem',
      md: '0.75rem',
      lg: '1rem',
      xl: '1.5rem',
      '2xl': '2rem',
      full: '9999px',
    }
  },
  roseGarden: {
    id: 'roseGarden',
    name: 'Розовый сад',
    colors: {
      primary: '#be185d',
      primaryForeground: '#ffffff',
      background: '#fff1f2',
      foreground: '#881337',
      card: '#ffffff',
      cardForeground: '#881337',
      muted: '#fce7f3',
      mutedForeground: '#9d174d',
      border: '#fbcfe8',
      textSecondary: '#9d174d',
      error: '#dc2626',
      warning: '#d97706',
      success: '#059669',
    },
    typography: {
      fontFamily: '"Lato", system-ui, -apple-system, sans-serif',
      fontFamilyHeading: '"Playfair Display", Georgia, serif',
    },
    radius: {
      xs: '0.5rem',
      sm: '0.75rem',
      md: '1rem',
      lg: '1.5rem',
      xl: '2rem',
      '2xl': '2.5rem',
      full: '9999px',
    }
  },
};

/**
 * Получить CSS переменные для темы
 * @param {string} themeKey - ключ темы
 * @returns {string} CSS с переменными
 */
export function getThemeCSS(themeKey) {
  const theme = THEME_PRESETS[themeKey] || THEME_PRESETS.default;
  const { colors, typography, radius } = theme;

  return `
    :root {
      --color-primary: ${colors.primary};
      --color-primary-foreground: ${colors.primaryForeground};
      --color-background: ${colors.background};
      --color-foreground: ${colors.foreground};
      --color-card: ${colors.card};
      --color-card-foreground: ${colors.cardForeground};
      --color-muted: ${colors.muted};
      --color-muted-foreground: ${colors.mutedForeground};
      --color-border: ${colors.border};
      --color-text-secondary: ${colors.textSecondary};
      --color-error: ${colors.error};
      --color-warning: ${colors.warning};
      --color-success: ${colors.success};
      --font-family: ${typography.fontFamily};
      --font-family-heading: ${typography.fontFamilyHeading};
      --radius-xs: ${radius.xs};
      --radius-sm: ${radius.sm};
      --radius-md: ${radius.md};
      --radius-lg: ${radius.lg};
      --radius-xl: ${radius.xl};
      --radius-2xl: ${radius['2xl']};
      --radius-full: ${radius.full};
    }
  `;
}

/**
 * Получить inline styles объект для темы (для React)
 * @param {string} themeKey - ключ темы
 * @returns {Object} объект стилей с CSS переменными
 */
export function getThemeStyles(themeKey) {
  const theme = THEME_PRESETS[themeKey] || THEME_PRESETS.default;
  const { colors, typography, radius } = theme;

  return {
    '--color-primary': colors.primary,
    '--color-primary-foreground': colors.primaryForeground,
    '--color-background': colors.background,
    '--color-foreground': colors.foreground,
    '--color-card': colors.card,
    '--color-card-foreground': colors.cardForeground,
    '--color-muted': colors.muted,
    '--color-muted-foreground': colors.mutedForeground,
    '--color-border': colors.border,
    '--color-text-secondary': colors.textSecondary,
    '--color-error': colors.error,
    '--color-warning': colors.warning,
    '--color-success': colors.success,
    '--font-family': typography.fontFamily,
    '--font-family-heading': typography.fontFamilyHeading,
    '--radius-xs': radius.xs,
    '--radius-sm': radius.sm,
    '--radius-md': radius.md,
    '--radius-lg': radius.lg,
    '--radius-xl': radius.xl,
    '--radius-2xl': radius['2xl'],
    '--radius-full': radius.full,
  };
}

/**
 * Получить Google Fonts URL для темы
 * @param {string} themeKey - ключ темы
 * @returns {string|null} URL для загрузки шрифтов или null
 */
export function getThemeFontsUrl(themeKey) {
  const fontUrls = {
    default: 'https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700&family=Source+Sans+3:wght@400;500;600;700&display=swap',
    forest: 'https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@400;500;600;700&display=swap',
    darkElegant: 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap',
    oceanBreeze: 'https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;500;600;700&family=Montserrat:wght@500;600;700&display=swap',
    roseGarden: 'https://fonts.googleapis.com/css2?family=Lato:wght@400;700&family=Playfair+Display:wght@500;600;700&display=swap',
  };
  return fontUrls[themeKey] || fontUrls.default;
}

export default THEME_PRESETS;
